import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, withGoogleMap, withScriptjs, InfoWindow} from "react-google-maps"
import { connect } from 'react-redux';
import {setInventoryItem, updateSelectedMapItem} from './../../actions/inventoryActions';

class HitMapMarker extends React.Component {   

    constructor(props){
        super(props);
        this.state = {
            open : false
        }
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        
        let {lat, lng} = this.props.hit._rankingInfo.matchedGeoLocation;
        return (

            
            <Marker onClick={()=>{this.props.updateSelectedMapItem(this.props.hit)}} position={{lat: lat, lng:lng }}>
            {
                (this.props.mapSelection.objectID==this.props.hit.objectID) ? <InfoWindow onCloseClick={()=>{this.props.updateSelectedMapItem(null)}}>
                <div>
                    

                    <p className="f5 c-primary bold mb-1">
                    <span className="HitMapMarker-logo" style={{backgroundImage : `url(${this.props.hit.logo})`}}  />
                    {this.props.hit.charityName}</p>
                    <p className="f5 c-primary m-0">{this.props.hit.name}</p>
                    <p className="HitMapMarker-decscription m-0">{this.props.hit.description}</p>
                    <a className="bold f5 c-primary" onClick={()=>{this.props.setInventoryItem(this.props.hit)}} >More</a>
                </div>
                </InfoWindow> : null
            }
            </Marker>
        )
    }
}

HitMapMarker.propTypes = {
    
}


const mapStateProps = (state) => {
    return {
        mapSelection : state.inventory.mapSelection
    };
}

export default  connect(mapStateProps, {setInventoryItem, updateSelectedMapItem})(HitMapMarker);



// WEBPACK FOOTER //
// ./src/components/common/HitMapMarker.js